<div class="sticky-top sticky-offset">
  <div class="top_menu" *ngIf="!router.url.includes('get-started') && !router.url.includes('corporate-login')">
    <button mat-button class="d-md-none d-none">
      <img src="../../assets/images/menu.svg" />
    </button>
    <app-nav></app-nav>
  </div>
</div>
<pktr-app-menu
  #pktrAppMenu
  [class.chat-route]="router.url.split('?')[0] === '/chat'"
  [class.hidden]="appState.isAppLoading$ | async"
  [env]="env"
  [idToken]="(appState.authToken$ | async)?.idToken || null"
  [appVersion]="appVersion"
>
  <app-deal-analysis-sheet
    *ngIf="sheetActive"
    [dealId]="dealAnalysisIdValue"
    [pmxPropertyId]="dealAnalysisPropertyIdValue"
  >
  </app-deal-analysis-sheet>
  <!-- 
  <app-property-details-sheet></app-property-details-sheet> -->

  <router-outlet></router-outlet>
</pktr-app-menu>

<div class="loadingMapFull opaque" *ngIf="appState.isAppLoading$ | async">
  <div class="flex_center fullHeight">
    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load
  </div>
</div>
